import { Component, computed, CUSTOM_ELEMENTS_SCHEMA, ViewEncapsulation } from '@angular/core';
import { BlockAbstractComponent, UtilsModule } from '@gallaghercp/core-frontend';
import { PulloutComponent } from '@gallaghercp/core-components/pullout';

@Component({
    selector: 'core-client-block-pullout',
    templateUrl: './block-pullout.component.html',
    imports: [PulloutComponent, UtilsModule],
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    styleUrl: './block-pullout.component.scss',
    encapsulation: ViewEncapsulation.None,
})
export class BlockPulloutComponent extends BlockAbstractComponent {
    showLinkAsEntireElement = false;

    get hasCustomHeadingStyles(): boolean {
        return this.isEnabled(this.block.data.useCustomHeadingStyles);
    }

    get hasCustomDescriptionStyles(): boolean {
        return this.isEnabled(this.block.data.useCustomDescriptionStyles);
    }

    get hasHeadingColorOverride(): boolean {
        return this.hasCustomHeadingStyles || this.isEnabled(this.block.data.useHeadingColorOverride);
    }

    get hasCustomButtonBorderRadius(): boolean {
        return this.isEnabled(this.block.data.useCustomButtonBorderRadius);
    }

    get imageAlignment(): 'top' | 'center' | 'bottom' {
        switch (this.block.data.imageAlignment?.toLowerCase()) {
            case 'top':
                return 'top';
            case 'bottom':
                return 'bottom';
            default:
                return 'center';
        }
    }

    get hasCtaIcon(): boolean {
        return (
            !!this.block.data.buttonIcon &&
            (this.block.data.includeCtaIcon === undefined ||
                this.block.data.includeCtaIcon === true ||
                this.block.data.includeCtaIcon === 1 ||
                this.block.data.includeCtaIcon === '1')
        );
    }

    pulloutConfig = computed(() => (this.configService.get('blocks') as any)?.pullout);

    override ngOnInit() {
        this.showLinkAsEntireElement = this.block.data.buttonVariant === 'Use entire pullout as link';
        if (this.showLinkAsEntireElement) {
            // Fallback to prevent link text from being empty
            this.block.data.ctaText = this.block.data.heading || 'Pullout link';
        }
        super.ngOnInit();
    }

    private isEnabled(value: unknown): boolean {
        return value === true || value === 1 || value === '1';
    }
}
